import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";

if (!environment.local) {
  enableProdMode();
}

/* Abilitato Sentry per tutti gli environment */
if (!environment.local) {
  Sentry.init({
    dsn: "https://a24e28532b8744a5b7cc32f2a903d17d@o560899.ingest.us.sentry.io/6049620",
    release: environment.version,
    environment: environment.environmentName,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    tracePropagationTargets: [environment.webUrl],
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
